<template>
  <component :is="'style'">
    {{
      css`
        @media print {
          table {
          }
          td {
            page-break-inside: avoid;
          }

          thead {
            display: table-header-group;
            margin-bottom: 100%;
          }
          * {
            print-color-adjust: exact;
            -webkit-print-color-adjust: exact;
          }
        }
        body {
          margin: 0;
          font-family: sans-serif;
          background-color: #faf9f6;
        }
        table {
          width: 100%;
          margin-bottom: 1rem;
          color: #372929;
          vertical-align: top;
          outline: solid 1px #d1cec6;
          caption-side: bottom;
          overflow: hidden;
          border-collapse: collapse;
          border-color: #e5e4db;
          border-top-color: rgb(229, 228, 219);
          border-right-color: rgb(229, 228, 219);
          border-bottom-color: rgb(229, 228, 219);
          border-left-color: rgb(229, 228, 219);
          background-color: white;
        }

        tbody {
          border-top: solid 3px #d1cec6;
        }
        thead tr {
          background-color: #e5e4db;
          font-size: 0.875rem;
          white-space: normal;
        }
        tr {
          border-width: 1px 0;
          /*
          word-break: break-all;
          */
        }
        td {
          font-size: 0.75rem;
          white-space: normal;
        }
        td,
        th {
          border-bottom: 1px solid #e5e4db;
          text-align: center;
          padding: 5px 2px;
        }
        tbody tr:last-child td {
          border-bottom: 0;
        }
        th:not(:first-child),
        td:not(:first-child) {
          border-left: 1px solid #e5e4db;
        }
        th {
          text-align: center;
          padding: 6px 8px;
        }
        footer {
          display: flex;
          justify-content: space-between;
          border-top: 1px solid #d1cec6 !important;
          align-items: center;
        }
        .logo {
          width: auto;
          height: 2rem;
        }

        .logo svg {
          height: 100%;
          width: auto;
        }

        .conference-title {
          margin-bottom: 10px;
        }

        .qr-code-wrap {
          display: flex;
          justify-content: flex-end;
        }

        .breakable {
          word-break: break-all;
        }
      `
    }}
  </component>
  <div style="padding: 20px; min-height: 100vh">
    <typography weight="500" size="1.5rem"> {{ capitalize(name) }} Report </typography>
    <typography
      v-if="entityName"
      color="gray700"
      tag="div"
      weight="400"
      size="1rem"
      style="padding-left: 20px; padding-top: 5px"
    >
      {{ capitalize(entityName) }}</typography
    >
    <section style="padding-top: 30px">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th scope="col" v-for="(col, i) in headers" :key="i">{{ col }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, j) in tableData" :key="j">
            <td
              v-for="(col, k) in row"
              :key="k"
              :class="{ breakable: col?.length && col.length > 70 }"
            >
              <a v-if="isLink(col)" :href="col">{{ col }}</a>
              <template v-else>
                {{ col }}
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <footer>
      <!-- <p>Generated at 12:00 AM on Tue, Jan 01, 2022 by PTC Wizard</p> -->
      <p>Generated at {{ dayjs().format("h:mm A on ddd, MMM Do, YYYY") }} by PTC Wizard</p>
      <figure class="logo" alt="PTC Wizard Logo">
        <Logo />
      </figure>
    </footer>
  </div>
</template>

<script setup lang="ts">
import dayjs from "dayjs";
import Logo from "@/assets/icons/logo-vertical-regular.svg";
import Typography from "@/components/typography.vue";

import advancedFormat from "dayjs/esm/plugin/advancedFormat";
import { capitalize } from "vue";

// @ts-ignore
dayjs.extend(advancedFormat);
defineProps<{
  headers: string[];
  tableData: any[][];
  name: string;
  win: Window;
  entityName?: string;
}>();

const css = (s: TemplateStringsArray, ...f: string[]): string => {
  return s.map((s, i) => s + (f[i] || "")).join("");
};

const isLink = (str: string) => {
  return /^http(s)?:[/]{2}[a-zA-Z]{2,}\.[a-zA-Z]{2,}.*/.test(str);
};
</script>
<style>
body {
  font-family: sans-serif;
  white-space: normal;
}
</style>
